<template src="./CancelModal/CancelModal.html"></template>
<script>
import { Webapi } from '@/Webapi'
import DropDown from '@/widgets/DropDown'

export default {
    name: 'CancelModal',
    components: {
        DropDown,
    },
    props: {
        uiData: Object,
        consignments: Array,
        onCancelClose: Function,
        resync: Function,
    },
    data: () => ({
        reason: null,
        comment: '',
        maxCommentCount: 255,
        totalRemainCommentCount: 255,
        commentError: false,
        status: 'PRE',
        errorMessages: [],
        cancelledConsignments: null,
    }),
    computed: {
        isSubmittable() {
            return this.reason !== null
        },
        tableConsignments() {
            if (this.cancelledConsignments !== null) {
                return this.cancelledConsignments
            }
            return this.consignments
        },
    },
    methods: {
        onReasonUpdated(value) {
            this.reason = value
        },
        onCancel() {
            this.cancelledConsignments = this.consignments
            this.status = 'IN_PROGRESS'
            const consignmentIds = this.consignments.map((consignment) => consignment.id)
            Webapi()
                .cancelConsignments(consignmentIds, this.comment, this.reason.value)
                .then((response) => this.onCancelResponse(response))
        },
        onCancelResponse(response) {
            this.status = response.status
            this.errorMessages = response.messages
            this.resync()
        },
        liveCountDown() {
            this.totalRemainCommentCount = this.maxCommentCount - this.comment.length
            this.commentError = this.totalRemainCommentCount <= 0
        },
    },
}
</script>
<style lang="scss" scoped>
@import '../../sass/variables';

.cancel-modal {
    height: 90vh;
}
.result-message {
    margin-top: 25px;
}
.loading {
    margin-top: 25px;
    width: 100%;
    height: 70px;
}
.tasks-table {
    width: 100%;
}
.error-list {
    list-style-type: disc;
    margin-left: 40px;
}
.reason-dropdown {
    margin-bottom: 20px;
}
.comment-length-countdown {
    text-align: end;
}
.comment-error {
    color: $danger;
}
</style>
